/* src/app/views/template/components/templates/digital/digital-spotlight-templates/digital-spotlight-template-list/digital-spotlight-template-list.component.scss */
/*# sourceMappingURL=digital-spotlight-template-list.component.css.map */
